import { useSelector } from "react-redux";
import { RedirectIfLoggedIn } from "../../../components/RedirectIfLoggedIn";
import { AppState } from "../../../store/configureStore";
import { useEffect, useState } from "react";
import { toast } from "../../..";
import { appStageToTitle } from "../../../helpers/appStageHelper";
import { Button, Input } from "semantic-ui-react";
import { forgotPassword } from "../../../services/authenticationService";
import logo from "../tscnet-logo.png";
import "./AdditionalLoginComponents.css";
import { emailRegex } from "../../../helpers/loginHelper";

export const ForgotPassword = () => {
    const stageState = useSelector((state: AppState) => state.appStage);
    const [sending, setSending] = useState(false);
    const [title, setTitle] = useState("");
    const [email, setEmail] = useState("");

    useEffect(() => {
        try {
            const title = appStageToTitle(stageState.stage);
            setTitle(title);
            document.title = title;
        } catch (err) {
            toast("Unable to determine environment", false, 3000);
        }
    }, [stageState.stage]);

    const handleForgotPassword = async () => {
        if (!emailRegex.test(email)) {
            toast("Invalid email format.", false, 3000);
        }

        setSending(true);
        try {
            await forgotPassword(email);
            toast("If you have an account, you'll receive an email for password reset instructions", true, 3000);
            setEmail("");
        } catch (err) {
            toast(
                err instanceof Error ? err.message : "Unable to send email with instructions.",
                false,
                3000
            );
        }
        setSending(false);
    };

    return (
        <div className="container-center">
            <RedirectIfLoggedIn />
            <div id="login-form-container">
                <img id="logo" src={logo} alt="Logo" />
                <h1 id="h1-login-a" className="tsc-blue">
                    {title}
                </h1>

                <div className="additional-login-component-container">
                    <h2>Forgot Password</h2>
                    <p>
                        Please enter your email and we will send you a message with instructions on
                        how to reset your password.
                    </p>

                    <div id="forgot-password-form-container" className="input-container">
                        <Input value={email} onChange={e => setEmail(e.target.value)} />
                        <Button primary loading={sending} onClick={handleForgotPassword}>
                            Send Email
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    );
};
